import React from "react";
import { useParams } from "react-router-dom";
import DynamicPage from "./DynamicPage";

const DynamicPageWrapper = ({ categories }) => {
  const { tripPath } = useParams();

  // Search for the trip in the nested category list
  const trip = categories
    .flatMap((category) => category.trips)
    .find((trip) => trip.path === tripPath);

  if (!trip) {
    return <h2 className="text-center mt-5">404 – Trip Not Found</h2>;
  }

  return <DynamicPage trip={trip} categories={categories} />;
};

export default DynamicPageWrapper;
